/**
 * @const
 * @enum {string}
 */
const FeatureName = {
  // client only
  FX_DURATION_MS: 'fxDurationMs',
  FX_DELAY_MS: 'fxDelayMs',
  AUTO_RECENT: 'arecent',
  AUTO_REFRESH: 'arefresh',
  ENGAGE: 'engage',
  ACCURACY_SCALE: 'accuracyScale',
  DEFAULT_PLACE: 'defaultPlace',
  ADMIN: 'admin',
  ANNO_UI_DEBUG: 'annoUIDebug',
  WORDCLOUD_UI_DEBUG: 'wcUIDebug',
  WORDCLOUD_DISABLE_TWEMOJI: 'wcDisableEmoji',
  BETA_CITIES: 'betaCities',
  AUTHOR_TYPE: 'authorType',
  COMPARE: 'compare',
  GA_AUTHOR: 'gaAuthor',
  AM_DEMOGRAPHICS: 'amDemographics',
  IGNORE_SEARCH_CACHE: 'noCache',
  CHANNEL_SETTINGS: 'channelSettings',

  CATEGORY: 'category',
  DEV_CATEGORY: 'devCategory',
  CV_DEMO: 'cvDemo',
  CV_MORE_LOGO: 'moreLogo',

  BROADSHALLOW_LANGUAGES: 'newKPLs',

  V3: 'v3',
  EXPORT_PDF: 'exportPDF',
  IS_HEAD: 'isHead',
  IS_TAIL: 'isTail',
  CARD_PADDING: 'cardPadding',
  RTL_DEBUG: 'rtlDebug',

  ALL_INSIGHT: 'allInsights',
  MOCK_NOW: 'mockNow',

  FEATURE_ADMIN: 'featureAdmin',
  FEATURE_TEST: 'featureTest',

  LOGO_IMPORT: 'logoImport',

  DATACUBE: 'datacube',

  THEME: 'theme',

  DEV_PORT: 'devPort'
}

/**
 * Get query parameters from uri
 * (an alternative to nb.util.Feature singleton constructor)
 * @return {object}
 */
function getFeaturesFromUri() {
  const features = {}
  const queryParam = window.location.search.substring(1)
  queryParam.split('&').forEach((param) => {
    const keyValuePair = param.split('=')
    features[keyValuePair[0]] = decodeURIComponent(keyValuePair[1])
  })
  return features
}

/**
 * Developer helper.
 * @return {string}
 */
export function getMockNow() {
  return getFeaturesFromUri()[FeatureName.MOCK_NOW]
}

export function isAllInsights() {
  return getFeaturesFromUri()[FeatureName.ALL_INSIGHT] === 'true'
}
